import * as React from 'react';

export const GettextContext = React.createContext();
export const LocationContext = React.createContext();
export const ConfigContext = React.createContext();
export const InjectorContext = React.createContext();
export const ModalContext = React.createContext();
export const MomentContext = React.createContext();
